// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Wzsp","containerItemsCenter":"Skeleton_containerItemsCenter__llouv"};